import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router } from '@angular/router';
import { StateService } from '../state.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthRedirectorService } from '../../core/auth/auth-redirector.service';
import { AuthService } from '../../core/auth/auth.service';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private state: StateService,
    private redirector: AuthRedirectorService,
    private auth: AuthService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!environment.production && route.queryParams.skipRouteGuard) {
      return true;
    }
    if (route.routeConfig.path === "ecommerce") {
      this.auth.loginAnonymus();
      return true;
    }
    if (!this.state.snapshot.auth.isAuthenticated) {
      this.redirector.redirect();
      return false;
    }

    return true;
  }

  canLoad(route: Route): boolean {
    if (!this.state.snapshot.auth.isAuthenticated) {
      this.redirector.redirect();

      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/guard/authenticated-guard.ts